import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { MaintenanceRoutineImportModel } from 'src/app/models/imports/maintenance-routine-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { MaintenanceRoutineModel } from 'src/app/models/maintenance/maintenance-routine.model';
import { MaintenanceRoutinePrintModel } from 'src/app/models/print/maintenance/maintenance-routine-print.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceRoutineService {
  constructor(private _httpClient: HttpClient) { }

  copyMaintenanceRoutineAsync(maintenanceRoutineOriginId: number, maintenanceRoutineDestinyId: number): Observable<MaintenanceRoutineModel> {
    return this._httpClient.get<MaintenanceRoutineModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutine.CopyMaintenanceRoutineAsync}/${maintenanceRoutineOriginId}/${maintenanceRoutineDestinyId}`)
  }

  createMaintenanceRoutine(maintenanceRoutineModel: MaintenanceRoutineModel): Observable<MaintenanceRoutineModel> {
    return this._httpClient.post<MaintenanceRoutineModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutine.CreateAsync}`,
      maintenanceRoutineModel);
  }

  deleteMaintenanceRoutine(maintenanceRoutineId: number): Observable<MaintenanceRoutineModel> {
    return this._httpClient.delete<MaintenanceRoutineModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutine.DeleteAsync}/${maintenanceRoutineId}`);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutine.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutine.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutine.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  getAllMaintenanceRoutinesForSelect(): Observable<any[]> {
    return this._httpClient.get<any[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutine.GetAllMaintenanceRoutinesForSelectAsync}`,);
  }

  getArticleById(articleId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutine.GetArticleByIdAsync}/${articleId}`);
  }

  getArticlesForMaintenanceRoutineAsync(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutine.GetArticlesForMaintenanceRoutineAsync}`,
      filters, { params: params }
    );
  }

  getMaintenanceRoutineById(id: number): Observable<MaintenanceRoutineModel> {
    return this._httpClient.get<MaintenanceRoutineModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutine.GetByIdAsync}/${id}`);
  }

  getColumnsAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutine.GetColumnsAsync}`);
  }

  GetColumnsForArticlesAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutine.GetColumnsForArticlesAsync}`);
  }

  getMaintenanceRoutineByArticleAsync(articleId: number): Observable<MaintenanceRoutineModel> {
    return this._httpClient.get<MaintenanceRoutineModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutine.GetMaintenanceRoutineByArticleAsync}/${articleId}`);
  }

  getMaintenanceRoutineWithPaginationAsync(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutine.GetMaintenanceRoutineWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  setActiveAsync(maintenanceRoutineId: number): Observable<MaintenanceRoutineModel> {
    return this._httpClient.put<MaintenanceRoutineModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutine.SetActiveAsync}/${maintenanceRoutineId}`,
      null);
  }

  getMaintenanceRoutinePrint(maintenanceRoutineId: number, companyId: number, articleCode: number): Observable<MaintenanceRoutinePrintModel> {
    const params = new HttpParams().set('maintenanceRoutineId', maintenanceRoutineId).set('companyId', companyId).set('articleCode', articleCode)
    return this._httpClient.get<MaintenanceRoutinePrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutine.GetMaintenanceRoutineByKeysByPrintAsync}`,
      { params: params });
  }

  getEmptyMaintenanceRoutinePrint(): Observable<MaintenanceRoutinePrintModel> {
    return this._httpClient.get<MaintenanceRoutinePrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutine.GetEmptyMaintenanceRoutinePrint}`);
  }

  importMaintenanceRoutine(maintenanceRoutineImports: Array<MaintenanceRoutineImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutine.ImportMaintenanceRoutine}`, maintenanceRoutineImports);
  }
}
